import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewrite1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconRewrite1"><Path fillRule="evenodd" clipRule="evenodd" d="M6.75 1.93945L9.56066 4.75011L6.75 7.56077L5.68934 6.50011L6.68934 5.50011H3.5V18.5001H12V20.0001H2V4.00011H6.68934L5.68934 3.00011L6.75 1.93945ZM12 4.00011H22V20.0001H17.3107L18.3107 21.0001L17.25 22.0608L14.4393 19.2501L17.25 16.4395L18.3107 17.5001L17.3107 18.5001H20.5V5.50011H12V4.00011ZM8 9.25011H16V10.7501H8V9.25011ZM8 13.2501H14V14.7501H8V13.2501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewrite1;
